import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const resolveImageUrl = (u) =>
  u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

export const optimizedImageUrl = (u, w = 800) => {
  if (!u) return u;
  if (u.includes("images.unsplash.com")) {
    return `${u}${u.includes("?") ? "&" : "?"}w=${w}&q=70&auto=format`;
  }
  return u;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
